import { render, staticRenderFns } from "./tmdetail.vue?vue&type=template&id=2ce0c205&scoped=true&"
import script from "./tmdetail.vue?vue&type=script&lang=js&"
export * from "./tmdetail.vue?vue&type=script&lang=js&"
import style0 from "./tmdetail.vue?vue&type=style&index=0&id=2ce0c205&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0c205",
  null
  
)

export default component.exports